import React, {useState, useEffect} from "react"
import { Link } from "gatsby"
import styled from 'styled-components'

import MenuBurger from '../../atoms/MenuBurger/index'
import MenuFuncContainer from '../../molecules/MenuFuncContainer'
import SearchContainer from '../../molecules/SearchContainer'
import LogoIcon from '../../atoms/LogoIcon'

import {colors} from '../../utils/styles'

export default () => {
  const [isTop, setIsTop] = useState(true)
  useEffect(() => {
    window.addEventListener('scroll', (e) => {
      if (window.scrollY > 20) setIsTop(false)
      else setIsTop(true)
    })
  }, [])

  return (
    <>
      <Header isTop={isTop}>
        <Nav>
          <LogoContainer>
            <Link to="/">
              <Logo width={50} height={50} color={isTop ? colors.green : colors.white}/>
            </Link>
          </LogoContainer>
          <SearchContainer isTop={isTop}/>
          <MenuBurger isTop={isTop}/>
          <MenuFuncContainer isTop={isTop}/>
        </Nav>
      </Header>
    </>
  )
}

const Header = styled.header`
  width: 100%;
  background-color: ${props => props.isTop ? props.theme.white : 'rgba(0, 0, 0, 0.7)'};
  height: 70px;
  position: fixed;
  z-index: 300;
`
const Nav = styled.nav`
  position: relative;
  width: 100%;
  padding: 0.4rem 1rem 0.3rem 2rem;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
`
const LogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const Logo = styled(LogoIcon)`
  width: 50px;
  height: 50px;
  color: white;
`
